import Vue from 'vue';
import Router from 'vue-router';

const _import = require('./_import_' + process.env.NODE_ENV);
import Full from '@/containers/Full';
// Views - Pages
import Page404 from '@/views/errorPages/Page404'
import Page500 from '@/views/errorPages/Page500'
/* login */
const Login = _import('login/index');
Vue.use(Router);
//所有权限通用路由表
//如首页和登录页和一些不用权限的公用页面
export const constantRouterMap = [
    {path: '/login', component: Login, hidden: true},
    {
        path: '/pages', redirect: '/pages/p404', name: 'Pages',
        component: {
            render(c) {
                return c('router-view')
            }
            // Full,
        },
        children: [{path: '404', name: 'Page404', component: _import('errorPages/Page404')},
            {path: '500', name: 'Page500', component: _import('errorPages/Page404')},
        ]
    }


]
//实例化vue的时候只挂载constantRouter
export default new Router({
    mode: 'hash',
    linkActiveClass: 'open active',
    scrollBehavior: () => ({y: 0}),
    routes: constantRouterMap
});
// 引入i18n
import VueI18n from "vue-i18n"
// 这里需要注册使用语言包
Vue.use(VueI18n);
Vue.locale = () => {
};
//引入iview提供的语言包
import zhLocale from "iview/src/locale/lang/zh-CN";
import enLocale from "iview/src/locale/lang/en-US";
import twLocale from "iview/src/locale/lang/zh-TW";

// 引入自定义的语言包
import cn from "@/language/zh-CN";
import tw from "@/language/zh-TW";
import us from "@/language/en-US";

// 自己写的语言包，并封装成对象
const messages = {
    zh: Object.assign(cn, zhLocale),
    en: Object.assign(us, enLocale),
    tc: Object.assign(tw, twLocale)
};
// 设置参数，创建 Vuei18n 的实例。需要将他挂载全局的所有组件上
const i18n = new VueI18n({
    // set locale 本地存储记录当前选中的语言是哪一种/默认的是哪种语言
    locale: localStorage.getItem("language") || "zh",
    messages, // set locale messages,在构造器中配置这个语言包
    silentTranslationWarn: true
});
const validVue = Vue.extend({i18n});
//异步挂载的路由
//动态需要根据权限加载的路由表
export const asyncRouterMap = [

    {
        path: '/',
        redirect: '/fastQuery',
        name: new validVue().$t('home'),
        component: Full,
        hidden: false,
        meta: {role: [], permission: []}, //页面需要的权限
        children: [
            {
                path: '/fastQuery',
                name: new validVue().$t('venueFastQuery'),
                icon: "ios-globe-outline",
                meta: {role: [], permission: []},
                component: _import('FastQuery')
            },
            {
                path: '/fastQueryOld',
                name: new validVue().$t('venueFastQueryOld'),
                icon: "ios-globe-outline",
                hidden: true,
                meta: {role: [], permission: []},
                component: _import('FastQueryOld')
            },
            {
                path: '/cdrToday',
                name: new validVue().$t('cdrListToday'),
                icon: "ios-laptop",
                meta: {role: [], permission: []},
                component: _import('CdrToday')
            },
            // {
            //     path: '/queryCard',
            //     name: new validVue().$t('wirteCardMissingQuery'),
            //     icon: "ios-analytics-outline",
            //     meta: {role: [], permission: []},
            //     component: _import('QueryCard')
            // },
            {
                path: '/account',
                name: new validVue().$t('cardNumberManagement'),
                icon: "ios-list-box-outline",
                meta: {role: [], permission: []},
                component: _import('Account')
            },
            // {
            //     path: '/otaSimList',
            //     name: new validVue().$t('otaSimManage'),
            //     icon: "ios-list-box-outline",
            //     meta: {role: [], permission: []},
            //     component: _import('OtaSim')
            // },
            {
                path: '/accountAssign',
                name: new validVue().$t('cardNumberAssignment'),
                icon: "ios-open-outline",
                meta: {role: [], permission: []},
                component: _import('AccountAssign')
            },
            {
                path: '/merchant',
                name: new validVue().$t('merchantManagement'),
                icon: "ios-contact-outline",
                meta: {role: [], permission: []},
                component: _import('Merchant')
            },
            {
                path: '/agent',
                name: new validVue().$t('agentManagement'),
                icon: "ios-contacts-outline",
                meta: {role: [], permission: []},
                component: _import('Agent')
            },
            {
                path: '/product',
                name: new validVue().$t('packageManagement'),
                icon: "ios-folder-outline",
                meta: {role: [], permission: []},
                component: _import('Product')
            },
            // {
            //     path: '/otaProductList',
            //     name: new validVue().$t('otaPackageManage'),
            //     icon: "ios-folder-outline",
            //     meta: {role: [], permission: []},
            //     component: _import('OtaProduct')
            // },

            // {
            //     path: '/productImsi',
            //     name: new validVue().$t('packageResources'),
            //     icon: "ios-folder-open-outline",
            //     meta: {role: [], permission: []},
            //     component: _import('ProductImsi')
            // },
            {
                path: '/usageStat',
                name: new validVue().$t('statisticalReport'),
                icon: "md-stats",
                meta: {role: [], permission: []},
                component: _import('UsageStat')
            },
            {
                path: '/rechargeLog',
                name:  new validVue().$t('rechargeLog'),
                icon: "ios-paper-outline",
                meta: {role: [], permission: []},
                component: _import('RechargeLog')
            },
            {
                path: '/topUpLog',
                name:  new validVue().$t('topUpLog'),
                icon: "ios-paper-outline",
                meta: {role: [], permission: []},
                component: _import('TopUpLog')
            },
            {
                path: '/role',
                name: new validVue().$t('roleManagement'),
                icon: "ios-nuclear-outline",
                meta: {role: [], permission: []},
                component: _import('Role')
            },
            {
                path: '/userOperateLog',
                name:  new validVue().$t('userActionLog'),
                icon: "md-paper",
                meta: {role: [], permission: []},
                component: _import('UserOperateLog')
            },
            {
                path: '/withdrawLog',
                name: new validVue().$t('withdrawLog'),
                icon: "md-archive",
                meta: {role: [], permission: []},
                component: _import('WithdrawLog')
            },
            {
                path: '/cdrSimList',
                name:  new validVue().$t('cdrSimList'),
                icon: "ios-list-box-outline",
                meta: {role: [], permission: []},
                component: _import('CdrSimList')
            },
            {
                path: '/taskList',
                name:  new validVue().$t('taskTopupList'),
                icon: "ios-list-box-outline",
                meta: {role: [], permission: []},
                component: _import('TaskTopup')
            },
            {
                path: '/ordersExcel',
                name: new validVue().$t('orderFile'),
                icon: "md-archive",
                meta: {role: [], permission: []},
                component: _import('OrderExcel')
            },
            {
                path: '/change-ip',
                name: new validVue().$t('changeRoute'),
                icon: "md-git-network",
                meta: {role: [], permission: []},
                component: _import('ChangeIP')
            },
            {
                path: '/change-ip-rate',
                name: new validVue().$t('routeRate'),
                icon: "md-pricetag",
                meta: {role: [], permission: []},
                component: _import('ChangeIpRate')
            },
            {
                path: '/agentIpFeeLog',
                name: new validVue().$t('agentIpFeeLogList'),
                icon: "ios-paper-outline",
                meta: {role: [], permission: []},
                component: _import('AgentIpFeeLog')
            },
            {
                path: '/esimPurchase',
                name: new validVue().$t('esimPurchase'),
                icon: "ios-list-box-outline",
                meta: {role: [], permission: []},
                component: _import('EsimPurchase')
            }

        ]
    },
    {path: '*', redirect: '/pages/404', hidden: true}

];



// WEBPACK FOOTER //
// ./src/router/index.js